import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as Ticket } from '../../components/icons/ticket.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import CustomInput from '../../components/components/custom_input/customInput';
import {setKeyword, setSearchValue, setAddEventMode } from "../../store/eventsSlice";

// Akcje dla tabeli użytkowników
export const userActions = {
  // deleteSelected: (selectedIds) => {
  //   console.log('Usuń zaznaczone użytkowników:', selectedIds);
  //   alert('W trakcie implementacji!')
  //   // Logika usuwania użytkowników na podstawie zaznaczonych ID
  // },
  // changeTab: (tabName, dispatch, setActiveUsersTab) => {
  //   console.log('Zmieniono zakładkę na:', tabName);
  //   dispatch(setActiveUsersTab(tabName));
  // },
};

// Konfiguracja nagłówków tabeli
export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rowsUsers, checkedItems) => [
  <input
  type="checkbox"
  checked={rowsUsers.every((row) => checkedItems.includes(row[1]))} // Sprawdzenie, czy wszystkie elementy są zaznaczone
  onChange={(e) => {
    const allIds = rowsUsers.map((row) => row[1]); // Pobierz ID wszystkich elementów
    if (e.target.checked) {
      // Dodaj wszystkie elementy do checkedItems
      dispatch({ type: 'users/setCheckedItems', payload: [...new Set([...checkedItems, ...allIds])] });
    } else {
      // Usuń wszystkie elementy z checkedItems
      dispatch({ type: 'users/setCheckedItems', payload: checkedItems.filter((id) => !allIds.includes(id)) });
    }
  }}
/>,
  'ID',
  <div className="table-columns-headers">
    <div>Akcje</div>
  </div>,
  <div className="table-columns-headers">
    <div>Data dodania</div>
    <SortArrows
      upColor={sortBy === 'added_on' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'added_on' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'added_on') {
          dispatch(setSorting({ sortBy: 'added_on', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'added_on', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Nazwa wydarzenia</div>
    <SortArrows
      upColor={sortBy === 'name' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'name' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'name') {
          dispatch(setSorting({ sortBy: 'name', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'name', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Lokalizacja</div>
    <SortArrows
      upColor={sortBy === 'city' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'city' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'city') {
          dispatch(setSorting({ sortBy: 'city', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'city', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Rozpoczęcie</div>
    <SortArrows
      upColor={sortBy === 'start_date' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'start_date' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'start_date') {
          dispatch(setSorting({ sortBy: 'start_date', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'start_date', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Zakończenie</div>
    <SortArrows
      upColor={sortBy === 'end_date' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'end_date' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'end_date') {
          dispatch(setSorting({ sortBy: 'end_date', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'end_date', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Kategoria</div>
    <SortArrows
      upColor={sortBy === 'category_id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'category_id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'category_id') {
          dispatch(setSorting({ sortBy: 'category_id', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'category_id', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Status</div>
    <SortArrows
      upColor={sortBy === 'is_active' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'is_active' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'is_active') {
          dispatch(setSorting({ sortBy: 'is_active', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'is_active', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
];

// Szerokości kolumn
export const headerWidths = ['42px', '50px', '62px', '150px', '1fr', '2fr', '150px', '150px', '180px', '150px'];

// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: Ticket,
    name: 'Wydarzenia',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Wydarzenia' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Wydarzenia', dispatch, setActiveUsersTab),
    toggleActive: true,
  }
];

// Konfiguracja przycisków
export const buttonsConfig = (toggleAddModal, addModalSetTrue ) =>[
  {
    icon: AddIcon,
    name: 'Dodaj wydarzenie',
    baseClass: 'custom-button-orange',
    bordersClassPrefix: 'border-orange-',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      addModalSetTrue();
      toggleAddModal();
    },
    toggleActive: false,
  },
];

export const empty = [];

// Konfiguracja lewej strony
export const leftSideConfig = [
  {
    component: CustomButton,
    props: {
      icon: Trash,
      name: 'Usuń zaznaczone',
      baseClass: 'custom-button-white',
      bordersClassPrefix: 'border-black-',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => userActions.deleteSelected([]), // Przekaż tutaj zaznaczone ID użytkowników
      toggleActive: false,
    },
  },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
        if (value.length >= 3 ) {
          dispatch(setKeyword(value)); // Aktualizuj stan w Reduxie
        } else {
          dispatch(setKeyword(null)); // Resetuj stan w Reduxie, jeśli mniej niż 3 znaki
        }
      }
      }
  },
];